module.exports = __webpack_public_path__ + "static/img/5.7b273bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/5.png
// module id = lGrx
// module chunks = 0